import { HttpInterceptorFn } from '@angular/common/http';
import { Config } from '../../common/config';

export const headerInterceptor: HttpInterceptorFn = (req, next) => {
  if (Config.TOKEN) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${Config.TOKEN}`
      }
    });
  }
  return next(req);
};
